import Setting from "@/setting";
import FingerprintJS from "@/libs/vendor/fp";
import db from "@/libs/utils/db";
import utils from "@/libs/utils/comm";
import { DeskInit, DeskGetMap } from "@/api/desk/pub";
export default {
  namespaced: true,
  state: {
      setting           : {},//基本设置
      visitorId         : "",//当前设备唯一码
      isMobile: false, // 是否为手机
      isTablet: false, // 是否为平板
      isDesktop: true, // 是否为桌面
      isFullscreen: false, // 是否切换到了全屏
      merchants: { // 商户信息
          name: "",
          logo: "",
          address: "",
          tel_man: "",
          tel: ""
      },
      map: null // 全局地图数据缓存（/desk/pub/getMap）
  },
mutations:{
        /**
         * @description 设置设备类型
         * @param {Object} state vuex state
         * @param {String} type 设备类型，可选值为 Mobile、Tablet、Desktop
         */
        setDevice (state, type) {
            state.isMobile = false;
            state.isTablet = false;
            state.isDesktop = false;
            state[`is${type}`] = true;
        },
        /**
         * @description 修改 menuCollapse
         * @param {Object} state vuex state
         * @param {Boolean} collapse 折叠状态
         * */
        updateMenuCollapse (state, collapse) {
            state.menuCollapse = collapse;
        },
        /**
         * @description 设置全屏状态
         * @param {Object} state vuex state
         * @param {Boolean} isFullscreen vuex
         * */
        setFullscreen (state, isFullscreen) {
            state.isFullscreen = isFullscreen;
        },
        /**
         * @description 更改指定布局配置
         * @param {Object} state vuex state
         * @param {Object} key layout 名称，对应 Setting.layout
         * @param {Object} value layout 值
         * */
        updateLayoutSetting (state, { key, value }) {
            state[key] = value;
        },
        /**
         * @description 设置商户信息
         * @param {Object} state vuex state
         * @param {Object} merchants 商户信息
         * */
        setMerchants (state, merchants) {
            state.merchants = merchants;
            db.setStorageSync("merchants", merchants);
        },
        /**
         * @description 设置地图数据缓存
         */
        setMap (state, payload) {
            state.map = payload;
        }

    },
  actions: {
    /**
     * @class pool
     * @param {Object} state vuex state
     * @param {Array} routes routes
     * // getCurrentInstance().appContext.config.globalProperties.$buy.emit('visitor');
     */
     async init ({ state, dispatch, commit }) {
        state.setting = Setting;
        db.init();
        let visitorId = db.getStorageSync("visitorId");
        if(visitorId == null) {
            var fpPromise = FingerprintJS.load();
            fpPromise.then(fp => fp.get()).then(result => {
                const visitorId = result.visitorId;
                state.visitorId = visitorId;
                db.setStorageSync("visitorId",visitorId);
            });
        } else {
            state.visitorId =   visitorId;
        }

        try {
            const cachedMerchants = db.getStorageSync("merchants");
            if (cachedMerchants) {
                commit("setMerchants", cachedMerchants);
            }

            const res = await DeskInit({});
            if (res && res.data) {
                const merchants = {
                    name: res.data.name || "",
                    logo: res.data.logo || "",
                    address: res.data.address || "",
                    tel_man: res.data.tel_man || "",
                    tel: res.data.tel || ""
                };
                commit("setMerchants", merchants);
            }

            await dispatch("loadMap");
        } catch (error) {
            console.error("初始化商户信息失败:", error);
        }
    },
    /**
     * 加载并缓存 getMap 数据，各页面可直接从 state 读取，也可主动调用以刷新
     */
    async loadMap ({ commit }) {
        try {
            const res = await DeskGetMap({});
            if (res && res.data != null) {
                commit("setMap", res.data);
            }
        } catch (e) {
            console.error("getMap 加载失败:", e);
        }
    }
  },
  getters: {
    map: (state) => state.map
  }
}
